'use client';

import { isBrowser } from 'motion/react';
import { PropsWithChildren } from 'react';

import CallToAction from '~/components/atoms/CallToAction';

interface PhoneCallToActionProps extends PropsWithChildren {
  phoneNumber: string | number;
}

const PhoneCallToAction: React.FC<PhoneCallToActionProps> = ({
  phoneNumber,
  children,
}) => {
  const triggerPhoneAction = () => {
    if (isBrowser && typeof window !== 'undefined') {
      window.location.href = `tel:${phoneNumber}`
    }
  };

  return (
    <CallToAction
      as="button"
      type="button"
      level={2}
      onClick={triggerPhoneAction}
    >
      {children}
    </CallToAction>
  );
};

export default PhoneCallToAction;
